let CustomerId = "";
let Sortdata = "";
let PageIndex = "";
let bodyData = "";
let selectedOption = "";
let Gridperpage = "20";


function scrollToProMedia() {
  const el = document.querySelector(".pro-media-wrapp");
  if (el) {
    const topPos = el.getBoundingClientRect().top + window.scrollY - 240; 
    window.scrollTo({
      top: topPos,
      behavior: "smooth"
    });
  }
}

if (!customElements.get('custom-sort')) {
    class CustomSort extends HTMLElement {
        constructor() {
            super();
            this.button = this.querySelector('.custom-sort__btn');
            this.listbox = this.querySelector('.custom-sort__listbox');
            this.options = this.querySelectorAll('.custom-sort__option');
            this.selected = this.querySelector('[aria-selected="true"]');
            this._init();
        }
        _init() {
            // Set default label
            if (this.selected) {
            this.button.querySelector('span').textContent =
                this.selected.textContent.trim();
            }

            // Toggle dropdown on button click
            this.button.addEventListener('click', () => this.toggle());

            // Handle option clicks
            this.options.forEach(option => {
            option.addEventListener('click', () => this._onSelect(option));
            });

            // Close when clicking outside
            document.addEventListener('click', e => {
            if (!this.contains(e.target)) {
                this.close();
            }
            });
        }

        toggle() {
            const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
            isExpanded ? this.close() : this.open();
        }

        open() {
            this.button.setAttribute('aria-expanded', 'true');
            this.listbox.classList.remove('invisible');
            this.listbox.hidden = false;
            this.listbox.setAttribute('aria-hidden', 'false');
        }

        close() {
            this.button.setAttribute('aria-expanded', 'false');
            this.listbox.classList.add('invisible');
            this.listbox.hidden = true;
            this.listbox.setAttribute('aria-hidden', 'true');
        }

        _onSelect(option) {
            // Update button label
            this.button.querySelector('span').textContent =
            option.textContent.trim();

            // Update aria-selected
            this.options.forEach(opt =>
                opt.removeAttribute('aria-selected')
            );
            option.setAttribute('aria-selected', 'true');

            // Update aria-activedescendant
            this.listbox.setAttribute('aria-activedescendant', option.id);

            // Save selected option
            this.selected = option;

            this.close();

            CustomerId = document.querySelector('.pro-media-wrapp').getAttribute('data-customer');
            Sortdata = option.getAttribute('data-value');
            PageIndex = 1;
            bodyData = {
              shop: Shopify.shop,
              page_no: PageIndex,
              tags: [ ],
              sortBy: Sortdata, // "Newest", "Oldest"
              customer_id: CustomerId,
              limit: Gridperpage
            };
            if(document.querySelector('.pro-media-content')){
                document.querySelector('.pro-media-content').classList.add('active-loader');
            }
            document.querySelector(".pro-media-grid__results ul.grid").innerHTML = "";
            scrollToProMedia();
            loadMediagrid(bodyData);
            
            this.dispatchEvent(
                new CustomEvent('custom-select-change', {
                    detail: { value: option.dataset.value }
                })
            );
        }
    }
    customElements.define('custom-sort', CustomSort);
}
const newfilterUrl = "https://pro3.signwarehouse.com/api/frontend/tags-by-category";

async function loadFilters() {
  try {
    const payload = {
      shop: Shopify.shop
    };
    const response = await fetch(newfilterUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    
    // result is an array (based on your example JSON)
    if (Array.isArray(result.data)) {
      const container = document.querySelector(".pro-media-drawer"); // update selector to your actual container
      if (!container) {
        console.error("No container (.pro-media-drawer) found in DOM");
        return;
      }

      result.data.forEach((group, groupIndex) => {
            // Create filter-group wrapper
            const filterGroup = document.createElement("div");
            filterGroup.className = "filter-group";

            // Toggle button
            const button = document.createElement("button");
            button.className = "filter-toggle active";
            button.type = "button";
            button.innerHTML = `
            <span class="disclosure__text">${group.category}</span>
            <span class="disclosure__toggle">
                <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="1.5" fill="none"></path>
                </svg>
            </span>
            `;
            filterGroup.appendChild(button);

            // Content
            const content = document.createElement("div");
            content.className = "filter-content collapsed active";

            const ul = document.createElement("ul");
            ul.setAttribute("role", "list");

            group.tags.forEach((tag) => {
            const li = document.createElement("li");
            const inputId = `filter.promedia.${group.category}-${tag.id}`;

            li.innerHTML = `
                <input type="checkbox" 
                    class="checkbox visually-hidden focus-label-before" 
                    id="${inputId}" 
                    name="filter.promedia.${group.category}" 
                    value="${tag.title}">
                <label for="${inputId}" class="filter__label flex items-start w-full m-0">
                <span class="flex-auto">${tag.title}</span>
                <span class="filter__count">(${tag.count})</span>
                </label>
            `;
            ul.appendChild(li);
            });

            content.appendChild(ul);

            // Optional "show more" link
            const showMore = document.createElement("a");
            showMore.href = "#";
            showMore.className = "show-more";
            showMore.textContent = "Show more";
            content.appendChild(showMore);

            filterGroup.appendChild(content);
            container.appendChild(filterGroup);

            // Collapse/expand toggle
            button.addEventListener("click", () => {
            content.classList.toggle("collapsed");
            });
            // Run once on load
            updateFilterContentVisibility();
      });
    } else {
      console.log("Unexpected result format:", result);
    }
  } catch (error) {
    console.error("Error fetching tags:", error);
  }
}

async function loadMediagrid(bodyData) {
  const loadResetDate = document.querySelector('.data-reset-date');
  if (loadResetDate) {
    loadResetDate.style.display = "none";
  }

  const mediaUrl = "https://pro3.signwarehouse.com/api/frontend/fetch-media";

  try {
    const response = await fetch(mediaUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bodyData)
    });

    // Media items
    const ErrorMsg = document.querySelector(".pro-media-content .pro-media-grid__noresults");
    const container = document.querySelector(".pro-media-grid__results ul.grid");

    // Update limit display
    const proMediaContent = document.querySelector('.pro-media-content');

    //  if customer don't have subscription
    if (response.status == 400) {
      const bad_result = await response.json();
      
      if (!container) {
        console.error("Missing .pro-media-grid__results ul.grid");
        return;
      }
      
      ErrorMsg.textContent = `${bad_result.message}`;
      ErrorMsg.classList.remove('hidded_msg');

      // Remove loading states
      proMediaContent?.classList.remove('active-loader');
      document.querySelector('.pro-media-grid__pagination .pagination--modern')?.classList.remove('lading-data');
      document.querySelector('.pro-media-wrapp')?.classList.add("close-drawer");

      throw new Error(`HTTP error! Status: ${response.status}`);
    } 
    
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const result = await response.json();
    const MonthLimit = result.data.customer_stats.media_limit;
    const Downloadfile = result.data.customer_stats.media_download;
    const HasNextPage = result.data.next_page;
    const CountReset = result.data.customer_stats.media_reset_at;
    const RemainFile = MonthLimit - Downloadfile;
    const displayText = MonthLimit == 0 && Downloadfile > MonthLimit ? `Null` : `${RemainFile} of ${MonthLimit}`;

    const downloadtarget = document.querySelector(".data-availe-download .data-remain-download");
    if (downloadtarget) downloadtarget.textContent = displayText;

    if (proMediaContent) {
      proMediaContent.classList.toggle('rich-limit-media', RemainFile <= 0);
    }

    // Pagination handling
    const Pagination = document.querySelector(".pro-media-grid__pagination");
    if (Pagination) {
      let pageLoadIndex = parseInt(result.data.current_page);
      if (HasNextPage) {
        Pagination.setAttribute('data-page', pageLoadIndex + 1);
        Pagination.classList.remove('hide-pagination');
      } else {
        Pagination.setAttribute('data-page', "1");
        Pagination.classList.add('hide-pagination');
      }
    }

    // Handle reset date
    const resetDate = document.querySelector('.data-reset-date');
    if (result.data.customer_stats.media_reset_at && resetDate) {
      const dateObj = new Date(CountReset);
      const formattedDate = `${String(dateObj.getDate()).padStart(2, '0')}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${dateObj.getFullYear()}`;
      const resetdateTarget = document.querySelector(".data-reset-date .data-reset-date-now");
      if (resetdateTarget) resetdateTarget.textContent = formattedDate;
      resetDate.style.display = "";
    } else if (resetDate) {
      resetDate.style.display = "none";
    }

    if (!container) {
      console.error("Missing .pro-media-grid__results ul.grid");
      return;
    }

    // Media items
    if (result?.data?.data?.length > 0) {
      ErrorMsg?.classList.add('hidded_msg');
      result.data.data.forEach(item => {
        const li = document.createElement("li");
        li.innerHTML = `
          <div class="card" data-index="${item.id}">
            <div class="propmeida_img_card" 
              style="--swatch-background: url('${item.media_url || ""}');">
            </div>
            <div class="propmedia_btn_card">
              <div class="btn btn--primary w-full propmedia_btn_call">
                Download all files
              </div>
            </div>
          </div>
        `;
        container.appendChild(li);
      });
    } else {
      ErrorMsg.textContent = result.message === "Pro subscription required"
        ? "Pro subscription required..!"
        : "Media Not Found..!";
      ErrorMsg.classList.remove('hidded_msg');
    }

    // Remove loading states
    proMediaContent?.classList.remove('active-loader');
    document.querySelector('.pro-media-grid__pagination .pagination--modern')?.classList.remove('lading-data');
    document.querySelector('.pro-media-wrapp')?.classList.add("close-drawer");

  } catch (error) {
    console.error("Error fetching media:", error);
  }
}


document.addEventListener("click", (e) => {
  const btn = e.target.closest(".filter-toggle");
  if (btn) {
    btn.classList.toggle("active");
    const content = btn.nextElementSibling;
    if (content) {
      content.classList.toggle("active");
    }
  }
});

document.addEventListener("change", (e) => {
  const checkbox = e.target.closest(
    ".pro-media-drawer input[type='checkbox']"
  );
  if (!checkbox) return;

  // Collect all checked checkboxes
  const tags = [];
  document
    .querySelectorAll(".pro-media-drawer input[type='checkbox']:checked")
    .forEach((cb) => {
      // Find parent filter-group
      const filterGroup = cb.closest(".filter-group");
      const categoryEl = filterGroup.querySelector(".disclosure__text");
      const category = categoryEl ? categoryEl.textContent.trim() : null;

      tags.push({
        title: cb.value,
        category: category || null
      });
    });
  CustomerId = document.querySelector('.pro-media-wrapp').getAttribute('data-customer');
  selectedOption = document.querySelector('.custom-sort__option[aria-selected="true"]');
  if (selectedOption) {
    Sortdata = selectedOption.getAttribute("data-value"); 
  }
  PageIndex = 1;
  bodyData = {
    shop: Shopify.shop,
    page_no: PageIndex,
    tags: tags,
    sortBy: Sortdata, // "Newest", "Oldest"
    customer_id: CustomerId,
    limit: 20
  };
  document.querySelector(".pro-media-grid__results ul.grid").innerHTML = "";
  if(document.querySelector('.pro-media-content')){
    document.querySelector('.pro-media-content').classList.add('active-loader');
  }
  scrollToProMedia();
  loadMediagrid(bodyData);
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".filter-content .show-more");
  if (btn) {
    e.preventDefault();
    const content = btn.closest(".filter-content");

    if (content.classList.contains("collapsed")) {
      content.classList.remove("collapsed");
      btn.textContent = "Show less";
    } else {
      content.classList.add("collapsed");
      btn.textContent = "Show more";
    }
  }
});
function updateFilterContentVisibility() {
  document.querySelectorAll(".filter-content").forEach((content) => {
    const labels = content.querySelectorAll("li");
    const btn = content.querySelector(".show-more");
    if (!btn) return;

    if (labels.length <= 5) {
      btn.style.display = "none";
    } else {
      btn.style.display = "";
    }
  });
}


document.addEventListener("DOMContentLoaded", function () {
    loadFilters();
    CustomerId = document.querySelector('.pro-media-wrapp').getAttribute('data-customer');
    selectedOption = document.querySelector('.custom-sort__option[aria-selected="true"]');
    if (selectedOption) {
        Sortdata = selectedOption.getAttribute("data-value"); 
    }
    PageIndex = 1;
    bodyData = {
      shop: Shopify.shop,
      page_no: PageIndex,
      tags: [ ],
      sortBy: Sortdata, // "Newest", "Oldest"
      customer_id: CustomerId,
      limit: Gridperpage
    };
    if(document.querySelector('.pro-media-content')){
        document.querySelector('.pro-media-content').classList.add('active-loader');
    }
    loadMediagrid(bodyData);

    const btn = document.querySelector(".promed-toolbar__filter-btn");
    const wrapper = document.querySelector(".pro-media-wrapp");

    if (btn && wrapper) {
        btn.addEventListener("click", function () {
          wrapper.classList.toggle("hide-filter");
          wrapper.classList.toggle("close-drawer");
        });
    }
});

async function downloadMedia(MediaId,CustomerId,e) {
  const Popdiv = e.target.closest(".promedia-popup");
  Popdiv.querySelector('.propmedia_download_btn').classList.add("loading-data");
  const url = "https://pro3.signwarehouse.com/api/frontend/download-media";
  CustomerId = document.querySelector('.pro-media-wrapp').getAttribute('data-customer');
  const bodyData = {
    shop : Shopify.shop,
    media_id: MediaId,
    customer_id: CustomerId
  };
  try {
    const response = await fetch(url, {
      method: "POST", // since you're sending data
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json(); // if API returns JSON
    const files = result.data.supported_media_urls;
    const zip = new JSZip();

    for (let url of files) {
      try {
        const resp = await fetch(url);
        if (!resp.ok) throw new Error(`Failed to fetch ${url}`);
        const blob = await resp.blob();
        const filename = url.split("/").pop();
        zip.file(filename, blob);
      } catch (err) {
        console.error("Error fetching:", url, err);
      }
    }

    const content = await zip.generateAsync({ type: "blob" });
    // Trigger download
    const linkDownload = document.createElement("a");
    linkDownload.href = URL.createObjectURL(content);
    linkDownload.download = "media-support-files.zip"; // final zip name
    document.body.appendChild(linkDownload);
    linkDownload.click();
    linkDownload.remove();
    URL.revokeObjectURL(linkDownload.href);
    

    const MonthLimit = result.data.monthly_limit;
    const Downloadfile = result.data.current_download;
    const RemainFile = MonthLimit - Downloadfile;
    const displayText = MonthLimit == 0 && Downloadfile > MonthLimit ? `Null` : `${RemainFile} of ${MonthLimit}`;

    const downloadtarget = document.querySelector(".data-availe-download .data-remain-download");
    if (downloadtarget) {
      downloadtarget.textContent = displayText;
    }
    if(RemainFile > 0){
      // console.log('Limit Available ..!');
      if(document.querySelector('.pro-media-content')){
        document.querySelector('.pro-media-content').classList.remove('rich-limit-media');
      }
    }else{
      // console.log('Limit Richhed ..!');
      if(document.querySelector('.pro-media-content')){
        document.querySelector('.pro-media-content').classList.add('rich-limit-media');
      }
    }
    Popdiv.querySelector('.propmedia_download_btn').classList.remove("loading-data");
    Popdiv.classList.remove("active-popup");
  } catch (error) {
    console.error("Error fetching media:", error);
  }
}

document.addEventListener("click", function (e) {
    // Check if it has .rich-limit-media
    if (e.target.closest(".rich-limit-media")) {
      console.log("Found .rich-limit-media → stop");
      return; // stop here
    }
    
    const popup = document.querySelector(".promedia-data-popup");
    const popupconf = document.querySelector(".promedia-result-popup");

    // Card click → open main popup
    if (e.target.closest(".propmeida_img_card") && !e.target.closest(".promedia-popup")) {
        const liEl = e.target.closest("li");
        if (!liEl) return;
        const IndexID = liEl.querySelector('.card').getAttribute('data-index');
        const itemImageUrl = liEl.querySelector('.propmeida_img_card').getAttribute('style');
        popup.querySelector('.card').setAttribute('data-index',IndexID);
        popup.querySelector('.propmeida_img_card').setAttribute('style',itemImageUrl);
        popup.classList.add("active-popup");
    }
    // Call result button click → switch popup
    if (e.target.closest(".propmedia_btn_call")) {
        const cardEl = e.target.closest(".card");
        if (!cardEl) return;
        const IndexID = cardEl.getAttribute('data-index');
        const itemImageUrl = cardEl.querySelector('.propmeida_img_card').getAttribute('style');
        popupconf.querySelector('.card').setAttribute('data-index',IndexID);
        popupconf.querySelector('.propmeida_img_card').setAttribute('style',itemImageUrl);
        popupconf.classList.add("active-popup");
        popup.classList.remove("active-popup");
    }
    // Close button click → close its parent popup
    if (e.target.closest(".close-btn-popup") || e.target.classList.contains('close-btn-popup')) {
        e.target.closest(".promedia-popup").classList.remove("active-popup");
    }
    if (e.target.closest(".propmedia_close_btn") || e.target.classList.contains('propmedia_close_btn')) {
        e.target.closest(".promedia-popup").classList.remove("active-popup");
    }
    if (e.target.closest(".propmedia_download_btn") || e.target.classList.contains('propmedia_download_btn')) {
        const MediaId = e.target.closest('.card').getAttribute('data-index');
        const CustomerId = document.querySelector('.pro-media-wrapp').getAttribute('data-customer');
        downloadMedia(MediaId,CustomerId,e);
    }
    if (e.target.closest(".pro-media-loadmore-btn") || e.target.classList.contains('pro-media-loadmore-btn')) {
        if(document.querySelector('.pro-media-grid__pagination')){
            document.querySelector('.pro-media-grid__pagination .pagination--modern').classList.add('lading-data');
        }
        const tags = [];
        document
            .querySelectorAll(".pro-media-drawer input[type='checkbox']:checked")
            .forEach((cb) => {
            // Find parent filter-group
            const filterGroup = cb.closest(".filter-group");
            const categoryEl = filterGroup.querySelector(".disclosure__text");
            const category = categoryEl ? categoryEl.textContent.trim() : null;

            tags.push({
                title: cb.value,
                category: category || null
            });
            });
        CustomerId = document.querySelector('.pro-media-wrapp').getAttribute('data-customer');
        selectedOption = document.querySelector('.custom-sort__option[aria-selected="true"]');
        if (selectedOption) {
            Sortdata = selectedOption.getAttribute("data-value"); 
        }
        PageIndex = document.querySelector(".pro-media-grid__pagination").getAttribute('data-page');
        bodyData = {
              shop: Shopify.shop,
              page_no: PageIndex,
              tags: tags,
              sortBy: Sortdata, // "Newest", "Oldest"
              customer_id: CustomerId,
              limit: Gridperpage
            };
        loadMediagrid(bodyData);
    }

    
    // Overlay click → close popup
    if (e.target.classList.contains("promedia-popup-overlay")) {
        e.target.closest(".promedia-popup").classList.remove("active-popup");
    }
    if (e.target.classList.contains("pro-media-header-close-btn")) {
      if(document.querySelector('.pro-media-wrapp')){
        document.querySelector('.pro-media-wrapp').classList.add("close-drawer");
      }
    }
});